import { Box, Button } from 'grommet';
import { Next } from 'grommet-icons';
import useResponsive from 'hooks/useResponsive';
import React from 'react';
import { useNavigate } from 'react-router';

const QuickLinks = () => {
  const { isMobile } = useResponsive();
  const navigate = useNavigate();
  return (
    <Box
      align="center"
      justify="center"
      direction={isMobile ? 'column' : 'row'}
      gap="medium"
    >
      <Button
        primary
        color="#00577C"
        size="large"
        label="Bli Medlem"
        icon={<Next />}
        reverse
        onClick={() => {
          navigate('/bli-medlem');
        }}
      />
      <Button
        primary
        color="#00577C"
        size="large"
        label="Terminliste"
        icon={<Next />}
        reverse
        onClick={() => {
          navigate('/seiltilbud');
        }}
      />
      <Button
        primary
        color="#00577C"
        size="large"
        label="Kontakt Oss"
        icon={<Next />}
        reverse
        onClick={() => {
          navigate('/info');
        }}
      />
    </Box>
  );
};

export default QuickLinks;
